

export const index = 2;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/docs/_layout.svelte.js')).default;
export const imports = ["_app/immutable/nodes/2.cdccU7_w.js","_app/immutable/chunks/mtF927Wn.js","_app/immutable/chunks/C8t-7i39.js","_app/immutable/chunks/IHki7fMi.js","_app/immutable/chunks/CUEW_ppn.js","_app/immutable/chunks/BwpWoHbM.js","_app/immutable/chunks/DC8ybcx3.js"];
export const stylesheets = ["_app/immutable/assets/2.DSi0qyjl.css"];
export const fonts = [];
